/**
 * Strips or replaces characters that can't be represented in latin1 (ISO 8859-1).
 * Used to sanitize strings before sending to the BE which uses latin1_swedish_ci collation.
 */
export const sanitizeToLatin = (value: string): string => {
  return (
    value
      .normalize('NFC')
      // Common Unicode → Latin-1 replacements
      .replace(/[\u2018\u2019\u201A]/g, "'")
      .replace(/[\u201C\u201D\u201E]/g, '"')
      .replace(/\u2013/g, '-')
      .replace(/\u2014/g, '-')
      .replace(/\u2026/g, '...')
      .replace(/\u00A0/g, ' ')
      .replace(/[^\x20-\xFF]/g, '')
  )
}
